import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  FETCH_MOTORBIKES,
  FETCH_MOTORBIKES_SUCCESS,
  FETCH_MOTORBIKES_FAILURE,
  MarketPlaceMotorbike
} from 'src/redux/motorbikesReducer'
import { RootReducer } from 'src/redux/rootReducer'

interface Response {
  total_pages: number
  total_count: number
  motorbikes: MarketPlaceMotorbike[]
  page: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMotorbikesFlow(): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/motorbikes'
    const currentPage = yield select((state: RootReducer) => state.motorbikesReducer.currentPage)
    const searchTerm = yield select((state: RootReducer) => state.motorbikesReducer.searchTerm)
    const stockTab = yield select((state: RootReducer) => state.motorbikesReducer.stockTab)
    const response: Response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {
        page: currentPage,
        query: searchTerm,
        where: {
          status: stockTab
        }
      }
    })
    yield put(
      FETCH_MOTORBIKES_SUCCESS({
        motorbikes: response.motorbikes,
        totalPages: response.total_pages,
        totalCount: response.total_count
      })
    )
  } catch (error) {
    yield put(FETCH_MOTORBIKES_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMotorbikesSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MOTORBIKES, FetchMotorbikesFlow)
}
